import { render, staticRenderFns } from "./PlusMinusButton.vue?vue&type=template&id=531f858a"
import script from "./PlusMinusButton.vue?vue&type=script&lang=js"
export * from "./PlusMinusButton.vue?vue&type=script&lang=js"
import style0 from "./PlusMinusButton.vue?vue&type=style&index=0&id=531f858a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports